/* unplugin-vue-components disabled */import { render } from "./StyleMessage.vue?vue&type=template&id=7a8459d8&scoped=true"
import script from "./StyleMessage.vue?vue&type=script&lang=js"
export * from "./StyleMessage.vue?vue&type=script&lang=js"

import "./StyleMessage.vue?vue&type=style&index=0&id=7a8459d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a8459d8"]])

export default __exports__